import BaseField           from "./baseField";
import { ValidationError } from "@/utils/forms/exceptions";
import t                   from "@/i18n/translator";

export default class FileField extends BaseField {
    constructor({
                    label, required = true, validators = [],
                    helpText, zeroValues = [null, undefined],
                    maxFileSize, allowedExtensions = []
                }) {
        super({
            label, required,
            helpText, zeroValues
        });
        this.maxFileSize = maxFileSize;
        this.allowedExtensions = allowedExtensions.map(e => e.toLowerCase());
        this.validators = [
            ...this.validators,
            ...validators,
            this.allowedSize.bind(this),
            this.allowedExtension.bind(this)
        ];
    }

    allowedSize(file) {
        if (file.size / 1024 > this.maxFileSize) {
            const converted = Math.round(this.maxFileSize / 1024);
            throw new ValidationError(t("file_size", file.name, converted));
        }
    }

    allowedExtension(file) {
        const chunks = file.name.split(".");
        const ext = chunks[chunks.length - 1].toLowerCase();
        if (!this.extensionListed(ext)) {
            const extList = this.allowedExtensions.join(", ");
            throw new ValidationError(t("file_type", file.name, extList));
        }
    }

    extensionListed(ext) {
        for (let i = 0; i < this.allowedExtensions.length; i++) {
            if (this.allowedExtensions[i] === ext) {
                return true;
            }
        }
        return false;
    }

}